var Vendd = (function (Vendd) {
    'use strict';

    Vendd.SubmitToExternalEndpoint = (function (SubmitToExternalEndpoint) {

        SubmitToExternalEndpoint.Messages = (function (Messages) {

            Messages.Submit = function (data) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.SubmitToExternalEndpoint.Messages.Submit', data);
            };

            Messages.Submit.className = 'Vendd.SubmitToExternalEndpoint.Messages.Submit';

            Messages.CreateLeadSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.SubmitToExternalEndpoint.Messages.CreateLeadSuccess', response.data[0]);
            };
            Messages.CreateLeadSuccess.className = 'Vendd.SubmitToExternalEndpoint.Messages.CreateLeadSuccess';

            Messages.CreateLeadFailure = function (response) {
                if (response.data === undefined) {
                    Vendd.MessageBus.VenddMessage.call(this, 'Vendd.SubmitToExternalEndpoint.Messages.CreateLeadFailure', response.responseJSON);
                }else {
                    Vendd.MessageBus.VenddMessage.call(this, 'Vendd.SubmitToExternalEndpoint.Messages.CreateLeadFailure', response.data[0]);
                }
            };
            Messages.CreateLeadFailure.className = 'Vendd.SubmitToExternalEndpoint.Messages.CreateLeadFailure';

            return Messages;

        })(SubmitToExternalEndpoint.Messages || {});

        return SubmitToExternalEndpoint;

    })(Vendd.SubmitToExternalEndpoint || {});

    return Vendd;

})(Vendd || {});